const expertiseItems = [
  {
    icon: "ri-smartphone-line",
    title: "iOS Platform Development",
    description: "Deep expertise in building native digital solutions for the iOS ecosystem, leveraging platform-specific capabilities to deliver seamless, responsive, and intuitive experiences.",
  },
  {
    icon: "ri-stack-line",
    title: "Scalable Architecture",
    description: "Systems are designed with scalability at their core, ensuring that software can grow and adapt without compromising performance or maintainability.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Performance Optimization",
    description: "Rigorous attention to efficiency across every layer of the stack, from rendering pipelines to data handling, delivering fast and fluid experiences.",
  },
  {
    icon: "ri-braces-line",
    title: "Clean Architecture",
    description: "Well-structured, modular codebases built on separation of concerns — making systems easier to maintain, test, and extend over time.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centered Design",
    description: "Interfaces and interactions shaped by usability principles and thoughtful design, ensuring that every solution feels natural and accessible.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Long-Term Technical Quality",
    description: "A steadfast commitment to code quality, documentation, testing, and continuous refinement — building software that endures.",
  },
];

export default function ExpertiseSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <p className="text-sm tracking-[0.25em] uppercase text-secondary-600 font-label font-medium mb-4">Areas of Expertise</p>
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground-900">
            What We Do
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {expertiseItems.map((item) => (
            <div
              key={item.title}
              className="group p-8 rounded-lg bg-background-50 border border-background-200/70 transition-colors duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100/70 mb-5">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-medium text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-light">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}